import { useDataModel } from '@thd-nucleus/data-sources';
import { orderDetailsV2DataModel, buildOrderDetailsV2Variables, OrderDetailsV2QueryParams } from './orderDetailsV2DataModel';
import { RawOrderDetailsV2Response } from './types';
import { QueryResult, toQueryResult } from './queryResult';

const PLACEHOLDER_VARIABLES = { userId: '', headers: { omsVersion: 'v2' }, request: {} };

/**
 * Fulfillment-drawer-only counterpart to useOrderDetailsQuery — see orderDetailsV2DataModel.ts's
 * header comment for why this is a separate query/model rather than an extension of the existing
 * one. `orderDetailsV2Params === null` means "not ready to fetch yet" (the drawer isn't open, or
 * the selected active order doesn't carry enough identifying data — see
 * adapters/fulfillmentDrawer.ts's buildActiveOrderDetailsParams) — the query is skipped and the
 * drawer renders from the raw activeOrders distribution alone, same as before this hook existed.
 */
export function useOrderDetailsV2Query(orderDetailsV2Params: OrderDetailsV2QueryParams | null): QueryResult<RawOrderDetailsV2Response> {
  const skip = orderDetailsV2Params === null;
  const variables = orderDetailsV2Params ? buildOrderDetailsV2Variables(orderDetailsV2Params) : PLACEHOLDER_VARIABLES;

  const response = useDataModel('orderDetails', {
    variables,
    dataModel: orderDetailsV2DataModel,
    skip,
    context: { withAuth: true }
  });

  return toQueryResult<RawOrderDetailsV2Response>({ ...response, data: response.data?.orderDetails }, skip);
}
